import React, {Component} from 'react';
import {
  Link,
} from 'react-router-dom';

// Public homepage only - hides temples that haven't been updated recently
// by default, with a toggle to see everything. Does NOT apply to the
// logged-in "my temples" view (UserTempleList.js passes userLoggedIn and
// its temples have no lastUpdated at all - see api/api.js's /user/temples
// route, which returns bare {id, name, hidden} rows), so that view is
// untouched below.
const RECENT_DAYS_THRESHOLD = 30;

/**
 * Days since a temple's last upload. Infinity for a temple with no
 * uploads at all, so it sorts/filters as "least recent".
 *
 * @param      {String}  date    d/m/yyyy, or falsy
 * @return     {Number}  days ago
 */
function daysSinceUpdate(date) {
  if (!date) return Infinity;

  let dateSplit = date.split(`/`);
  let updateDate = new Date(`${dateSplit[1]}/${dateSplit[0]}/${dateSplit[2]}`);
  let diff = new Date() - updateDate;

  return ~~(diff / (1000 * 60 * 60 * 24));
}

/**
 * Gets the last updated date label.
 *
 * @param      {Number}  daysAgo
 * @return     {String}  The last updated.
 */
function getLastUpdatedLabel(daysAgo) {
  switch (daysAgo) {
    case 0:
      return `Today`;
    case 1:
      return `Yesterday`;
    default:
      return `${daysAgo} days ago`;
  }
}

/**
 * List of temples.
 *
 * @class      TempleList (name)
 */
class TempleList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      showAll: false,
    };
  }

  toggleShowAll() {
    this.setState({
      showAll: !this.state.showAll,
    });
  }

  render() {

    const filterByRecency = !this.props.userLoggedIn;

    let templesList = (
      <li>
        <div className="loader dark"></div>
      </li>
    );
    let hiddenCount = 0;

    if (this.props.temples) {

      const decorated = this.props.temples.map(temple => ({
        temple,
        daysAgo: temple.lastUpdated ? daysSinceUpdate(temple.lastUpdated.date) : Infinity,
      }));

      const visible = (filterByRecency && !this.state.showAll)
        ? decorated.filter(({daysAgo}) => daysAgo <= RECENT_DAYS_THRESHOLD)
        : decorated;

      hiddenCount = decorated.length - visible.length;

      templesList = visible.map(({temple, daysAgo}) => (
        <li key={temple.id}
          className="list-group-item text-capitalize temple-info">
          <Link to={`temple/${temple.id}`}>
            <h4>
              {temple.name} Mandir
              <small className={`last-updated` + (temple.lastUpdated && !temple.lastUpdated.date ? ` last-updated-empty` : ``)}>
                {temple.lastUpdated && (temple.lastUpdated.date ? getLastUpdatedLabel(daysAgo) : `No uploads yet`)}
              </small>
            </h4>
          </Link>
        </li>
      ));

      if (filterByRecency && visible.length === 0 && decorated.length > 0) {
        templesList = (
          <li className="temple-list-empty text-center">
            No temples updated in the last {RECENT_DAYS_THRESHOLD} days.
          </li>
        );
      }
    }

    return (
      <div>
        {
          filterByRecency && (hiddenCount > 0 || this.state.showAll) && (
            <div className="temple-list-toggle text-center">
              <button type="button" onClick={this.toggleShowAll.bind(this)}>
                {
                  this.state.showAll
                    ? `Show recently updated only`
                    : `Show all temples (${hiddenCount} not updated in ${RECENT_DAYS_THRESHOLD} days)`
                }
              </button>
            </div>
          )
        }
        <ul className="list-group temple-list">
          {templesList}
        </ul>
      </div>
    );
  }
}

export default TempleList;



// WEBPACK FOOTER //
// ./js/TempleList.js